import styled from "styled-components";

export const FooterWrapper = styled.div`
  background: url("/assets/footer.png") -315px calc(100% + 547px) / 922px no-repeat;
`;

export const FooterContainer = styled.div`
  max-width: 1200px;
  width: 95%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  margin: 0 auto;
  margin-top: 80px;
`;

export const FooterHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 40px;
  margin-bottom: 40px;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
`;
export const FooterDescription = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
export const FooterSocial = styled.div`
  max-width: 1200px;
  width: 95%;
  margin: 0 auto;
  margin-top: 40px;
`;

export const FooterAuthority = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 80px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    & > :not(:first-child) {
      margin-top: 15px;
    }
  }
`;

export const FooterItems = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 40px;
`;

export const FooterItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 7.99px;
  svg {
    display: flex;
    align-self: flex-start;
    color: #71717a;
    transition: all 0.3s;
  }
  span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #71717a;
    transition: all 0.3s;
  }
  &:hover {
    svg {
      color: #e11d48;
    }
    span {
      color: #e11d48;
    }
  }
`;
